import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from "rxjs";

import { CategoryDTO } from "src/app/models/Categories/categoryDTO";
import { CategoryElementDTO } from "src/app/models/Categories/categoryElementDTO";
import { RolePermissionsService } from "../../services/role-permissions/role-permissions.service";

@Component({
  selector: "app-categories",
  templateUrl: "./categories.component.html",
  styleUrls: ["./categories.component.scss"],
})
export class CategoriesComponent implements OnInit {
  public locale: string = localStorage.getItem("locale");

  _categories: CategoryDTO[];

  @Input() selectedCategories: CategoryElementDTO[];
  @Input() set categories(categoryList: CategoryDTO[]) {
    if (categoryList) {
      this._categories = this.sortByMandatory(categoryList);
      this.setCategoriesForm(this._categories);
    }
  }
  @Input() formArray: FormArray;
  @Input() permissionResource: string;

  // Permissions«
  public canWrite$: Observable<boolean>;

  constructor(private fb: FormBuilder, public rolePermissionsService: RolePermissionsService) {}

  ngOnInit(): void {
    this.canWrite$ = this.rolePermissionsService.hasPermission(
       this.permissionResource,
      "WRITE"
    );
  }

  sortByMandatory(categories: CategoryDTO[]): CategoryDTO[] {
    return categories.slice().sort((x, y) => {
      return x.mandatory === y.mandatory ? 0 : x.mandatory ? -1 : 1;
    });
  }

setCategoriesForm(categories: CategoryDTO[]): void {
  this.canWrite$
    .subscribe((canEdit) => {
      categories.forEach((category) => {
        const selectedCategory = this.getSelectedCategory(category, this.selectedCategories);
        const control = this.fb.control(
          selectedCategory ? selectedCategory.code : "",
          category.mandatory ? Validators.required : []
        );

        if (!canEdit) {
          control.disable();
        }

        this.formArray.push(this.fb.group({
          [category.code]: control
        }));
      });
    });
}

  getSelectedCategory(
    category: CategoryDTO,
    selectedCategories: CategoryElementDTO[]
  ): CategoryDTO {
    if (!selectedCategories) {
      return;
    }
    return selectedCategories.find(
      (selCat) => selCat.categoryCode === category.code
    );
  }

  getCategoryElementsList(categoryControl: FormGroup): CategoryElementDTO[] {
    const [categoryCode] = Object.keys(categoryControl.controls);
    const category = this.getCategory(this._categories, categoryCode);
    return category.categoryElements;
  }

  getFormLabel(categoryControl: FormGroup): string {
    const [categoryCode] = Object.keys(categoryControl.controls);
    const category = this.getCategory(this._categories, categoryCode);
    return category.description;
  }

  getRequiredIndication(categoryControl: FormGroup): boolean {
    const [categoryCode] = Object.keys(categoryControl.controls);
    const category = this.getCategory(this._categories, categoryCode);
    return category.mandatory;
  }

  getCategory(categories: CategoryDTO[], categoryCode: string): CategoryDTO {
    return categories.find((category) => category.code === categoryCode);
  }

  getFormControlName(categoryControl: FormGroup): string {
    const [categoryCode] = Object.keys(categoryControl.controls);
    return categoryCode;
  }

  clearFormControl(categoryControl: FormGroup): void {
    const [categoryCode] = Object.keys(categoryControl.controls);
    categoryControl.controls[categoryCode].setValue("");
    this.formArray.markAsDirty();
  }
}
